import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import translate from 'components/hoc/translate';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import ListButton from 'components/button/ListButton';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { fetchProductMembership } from 'store/actions/product-memberships/fetchProductMemberships';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { updateProductMembership } from 'store/actions/product-memberships/updateProductMembership';
import ProductMembershipForm from '../create/ProductMembershipForm';
import utils from 'helpers/utils';

const ProductMembershipsEdit = (props) => {
    const {
        translate,
        dispatchForm,
        history,
        data,
        id,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    const handleSubmitForm = (values) => {
        return new Promise((resolve) => {
            dispatchForm({
                id,
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/product-memberships/${ id }/show`));
                },
                values: utils.diffObjects(data, values),
            });
        });
    };

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound /> ;
    }

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.product_memberships'),
            link: '/product-memberships',
        },
        {
            label: data.name,
            link: `/product-memberships/${ id }/show`,
        },
        {
            label: translate('actions.edit'),
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('resources.memberships.actions.edit', {
                    title: data.name,
                }) } />

                <Actions>
                    <ListButton url='/product-memberships' />
                </Actions>
            </Header>

            <Card>
                <CardText>
                    <ProductMembershipForm
                        form='product-memberships'
                        handleSubmitForm={ handleSubmitForm }
                        initialValues={ data }
                    />
                </CardText>
            </Card>
        </div>
    );
};

ProductMembershipsEdit.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProductMembership(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchProductMembership,
        resource: 'product-memberships',
    })
);

export default enhance(ProductMembershipsEdit);



// WEBPACK FOOTER //
// ./src/pages/product-memberships/edit/ProductMembershipsEdit.js